<template>
  <div class="height-100-p">
    <el-table
      :data="daysOfService.list"
      v-loading="daysOfService.loadingSearch"
      id="daysOfService-data-list"
      ref="dayOfServiceTable"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      @sort-change="handleSortChange"
      :default-sort="{prop: 'consigneeAccountName', order: 'ascending'}"
      stripe>
      <el-table-column
        prop="consigneeAccountName"
        :label="$t('daysOfService.consignee')"
        :min-width="12"
        sortable="custom"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.consigneeAccountName" placement="top">
            <span>{{ scope.row.consigneeAccountName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="consigneeCity"
        :label="$t('daysOfService.city')"
        :min-width="5"
        sortable="custom"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.consigneeCity" placement="top">
            <span>{{ scope.row.consigneeCity }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="consigneeState"
        :label="$t('daysOfService.state')"
        :min-width="4"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.consigneeState" placement="top">
            <span>{{ scope.row.consigneeState }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column v-for="column in daysOfService.dayColumns"
        :key="column.label"
        :prop="column.prop"
        :label="column.label"
        :min-width="column.minWidth"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row[column.value]" class="el-icon-success green-success"></i>
        </template>
      </el-table-column>

    </el-table>
    <div class="pagination-footer" v-show="daysOfService.total > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('daysOfService.totalDayOfService') }}</span>
           {{ daysOfService.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="daysOfService.actualFilters.rows"
        :current-page.sync="daysOfService.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="daysOfService.total"
        layout="sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import transformLabels from '@/plugins/unitDataTransformLabels';
import { DOS_SEARCH } from '@/store/actions';

export default {
  name: 'SearchSummary',
  mixins: [transformLabels],
  computed: {
    ...mapGetters(['daysOfService'])
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
      daysOfWeek: constants.DAYS_OPTIONS
    };
  },
  methods: {
    handleSearchChangePage(val) {
      this.$store.dispatch(DOS_SEARCH, { page: val });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch(DOS_SEARCH, { rows: val, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleSortChange({ prop, order }) {
      this.$store.dispatch(DOS_SEARCH, { orderField: prop, orderDirection: constants.TABLES.ORDER_DIRECTION[order] });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.current-date-bold {
  font-weight: bolder;
}
</style>
